module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "flourish",
      "src": "images/flourish.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I offer heartfelt gratitude to my enthusiastic beta readers: Renee Sevelitte, who found the first major story flaws; Tammy Thompson, who went above and beyond the task, meticulously pointing out typos, while giving me the honest truth about the first chapter; Pamela Hodgin, who earnestly read my story despite it being out of her normal genre of interest; and Holly Meyerhoff, who is almost too polite to be a beta reader, but made me rethink the latter half of the story.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Thanks to the young man at the San Francisco Cable Car Museum (whose name I didn't obtain), who gave me valuable information. And to Wendy Kramer, librarian in the San Francisco History Center at the San Francisco Public Library for sending much-needed primary sources.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Thanks to my cheering section. You know who you are. And, of course, thanks to my mom, who read the nearly final draft, chapter by chapter, right along with me. We had a fun time that night.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23b97ae2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section5.vue
// module id = 69
// module chunks = 0